<template>
  <div>
    <p role="status" class="sr-only">Generated 6 instructional strategies</p>
    <CharacteristicsSummary
      :summary-items="selectionSummaryItems"
      @reset="$emit('reset')"
    />
    <div class="ai-bg">
      <div class="strategy-container">
        <SDIStrategiesResultsSection
          v-for="strategyList in sortedStrategyLists"
          :key="`${strategyList.guideline}-strategies-card`"
          :guideline="capitalize(strategyList.guideline)"
          :strategies="strategyList.strategies"
          :trace-i-d="traceID"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SDIStrategiesResultsSection from '@/components/sdistrategies/SDIStrategiesResultsSection.vue'
import { htmlIDFromString } from '@/util/html_utils'
import CharacteristicsSummary from '@/components/sdistrategies/CharacteristicsSummary.vue'

export default {
  name: 'SDIStrategiesResults',
  methods: {
    htmlIDFromString,
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  },
  components: { CharacteristicsSummary, SDIStrategiesResultsSection },
  props: {
    generatedStrategies: {
      type: Object,
      required: true,
    },
    selectedCharacteristics: {
      type: Array,
      default() {
        return []
      }
    },
    traceID: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      udlGuidelines: ['engagement', 'representation', 'expression']
    }
  },
  computed: {
    sortedStrategyLists() {
      let sortedStrategies = []
      for (let guideline of this.udlGuidelines) {
        let strategies = this.generatedStrategies[guideline]
        sortedStrategies.push({strategies, guideline})
      }
      return sortedStrategies
    },
    selectionSummaryItems() {
      return this.selectedCharacteristics.map(characteristic => characteristic.name)
    }
  }
}
</script>

<style scoped lang='less'>
.ai-bg {
  margin-top: 2rem;
  border-radius: 0.625rem;
  padding: 0.1875rem;
}

/deep/ .strategy-container {
  border-radius: 0.5rem;
  background-color: white;
  padding: 1.25rem;
}
</style>
